import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'

export const MenuList = styled.div<{ $isMobileDrawerStyle?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  min-width: 180px;
  background-color: ${COLORS.white};
  border-radius: 8px;
  border: 1px solid ${COLORS.borderColor};
  box-shadow: 0px 4px 16px 0px rgba(56, 102, 255, 0.15);

  ${({ $isMobileDrawerStyle }) =>
    $isMobileDrawerStyle &&
    css`
      margin-top: 12px;
      box-shadow: none;
      border: none;
      gap: 8px;
    `}
`

export const MenuItem = styled.span<{
  $isMobileDrawerStyle?: boolean
  $isStrokedIcon?: boolean
}>`
  width: 100%;
  padding: 8px 4px;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;

  background-color: ${COLORS.white};

  border-radius: 4px;
  transition: all 0.3s ease;
  cursor: pointer;

  @media (min-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    &:hover {
      & p {
        color: ${COLORS.secondaryDark};
      }

      ${({ $isStrokedIcon }) =>
        $isStrokedIcon
          ? css`
              & svg path {
                stroke: ${COLORS.secondaryDark};
              }
            `
          : css`
              & svg path {
                fill: ${COLORS.secondaryDark};
              }
            `}

      background-color: ${COLORS.primaryLight};
    }
  }

  ${({ $isMobileDrawerStyle }) =>
    $isMobileDrawerStyle &&
    css`
      border-radius: 8px;
      border: 1px solid ${COLORS.borderColor};
      padding: 16px 24px;
    `}
`

export const IconWrapper = styled.div<{
  $width?: number
  $height?: number
  $isStrokedIcon?: boolean // to skip color change on stroked icons
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $width }) => ($width !== undefined ? `${$width}px` : '24px')};
  height: ${({ $height }) => ($height !== undefined ? `${$height}px` : '24px')};

  > svg {
    width: ${({ $width }) => ($width !== undefined ? `${$width}px` : '24px')};
    height: ${({ $height }) =>
      $height !== undefined ? `${$height}px` : '24px'};
  }
  ${({ $isStrokedIcon }) =>
    $isStrokedIcon
      ? css`
          > svg path {
            stroke: ${COLORS.secondarySemiDark};
          }
        `
      : css`
          > svg path {
            fill: ${COLORS.secondarySemiDark};
          }
        `}
`
